<script setup>
import { useRoute } from "vue-router"
const route = useRoute()
</script>
<template>
    <div class="p-4" style="font-weight: bold; font-size: 16px;">{{ route.query.content?route.query.content: ''  }}</div>
</template>